// extracted by mini-css-extract-plugin
export var experienceSection = "styles-module--experienceSection--1+NNT";
export var experienceInfoWrapper = "styles-module--experienceInfoWrapper--08HNH";
export var experienceTile = "styles-module--experienceTile--MPHQ0";
export var bigNumber = "styles-module--bigNumber--2o0IB";
export var experienceTileDiv = "styles-module--experienceTileDiv--PCWp-";